import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import api from "api";
import _ from "lodash";

const SkillFinder = connect(stateMap)((props) => {
    const [selectedSkill, setSelectedSkill]     = useState(false);
    const [searchingSkill, setSearchingSkill]   = useState(false);
    const [searchSkill, setSearchSkill]         = useState(props.skill ? [props.skill] : []);
    
    return (
        <div className="component-skill-finder">
            <input 
                type="text" 
                className={`${props.className ? props.className : 'form-control text'}`} 
                name="ExpTitle" 
                {...props}
                onChange={_.debounce((e) => {

                    props.onTextChange.apply(null, [e]);

                    setSearchSkill([]);

                    if(e.target.value.length < 3)
                    {
                        return;
                    }

                    setSearchingSkill(true);
                    
                    
                    return api('/Skill', 'get', {
                            search : e.target.value
                            ,posts_per_page : 10
                        }, 'Bearer ' + props.auth.token)
                        .then(response => {

                            setSearchingSkill(false);

                            setSearchSkill(response.skill);
                        })
                }, 200)}
                onBlur={(e) => {

                    props.onTextBlur.apply(null, [e]);

                    setSearchingSkill(false);
                }}
            />
            {
                searchingSkill && <span className="text-xs">Searching skill...</span>
            }
            {
                !searchingSkill && 
                <ul className="skill-pills">
                    {
                        searchSkill.map((skill) => (
                            <li className="skill-pill-wrapper" key={skill.SkillID}>
                                <a className={`btn btn-mini ${selectedSkill.SkillID === skill.SkillID ? 'btn-primary' : ''}`} href="#" onClick={e => {
                                    e.preventDefault();

                                    if(!selectedSkill)
                                    {
                                        setSelectedSkill(skill);
                                        
                                        props.onPillSelected.apply(null, [skill])
                                    }
                                    else
                                    {
                                        setSelectedSkill(false);
                                        
                                        props.onPillSelected.apply(null, [false])

                                    }


                                }} >{skill.SkillName}</a>
                            </li>
                        ))
                    }
                </ul>
            }
        </div>
    )
})

export { SkillFinder }